import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Btn } from "@/components/UI";
import { Plus, Pencil, ClipboardCheck, Trash2 } from "lucide-react";
import { fmtQty } from "@/lib/products";
import { MaterialStatus } from "@/components/materials/MaterialStatus";
import { MaterialFormModal } from "@/components/materials/MaterialFormModal";
import { MaterialCountModal } from "@/components/materials/MaterialCountModal";
import { MaterialHistoryModal } from "@/components/materials/MaterialHistoryModal";
import { History } from "lucide-react";

// Ürün Detayı → Ambalaj & Malzemeler (Malzeme Stok sayfası ile aynı kayıt).
export function ProductMaterials({ productId, canEdit }) {
  const [rows, setRows] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [form, setForm] = useState(null);
  const [count, setCount] = useState(null);
  const [hist, setHist] = useState(null);
  const load = () => api.get(`/products/${productId}/materials`).then(setRows).catch(() => setRows([]));
  useEffect(() => { load(); api.get("/suppliers").then((s) => setSuppliers(Array.isArray(s) ? s : [])).catch(() => {}); }, [productId]); // eslint-disable-line react-hooks/exhaustive-deps
  const del = async (m) => { if (window.confirm(`${m.name} silinsin mi? (Geçmiş için pasife almanız önerilir)`)) { await api.del(`/product-materials/${m.id}`); load(); } };
  // Modals are rendered OUTSIDE the Card: Card's backdrop-filter makes it the containing block for position:fixed.
  return (
    <>
    <Card className="p-5" data-testid="product-materials">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-semibold text-slate-700">Ambalaj & Malzemeler</div>
        {canEdit && <Btn size="sm" onClick={() => setForm({})} data-testid="product-materials-add"><Plus size={12} /> Malzeme Ekle</Btn>}
      </div>
      {!rows.length ? <div className="text-sm text-slate-500" data-testid="product-materials-empty">Bu ürüne bağlı malzeme yok.</div> : (
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-wider text-slate-500"><tr>
            {["Malzeme", "Tür", "Kullanım", "Mevcut", "Kritik", "Durum", "Tedarikçi", ""].map((h) => <th key={h} className="text-left px-2 py-1.5">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.id} className={`border-t border-slate-100 ${m.active ? "" : "opacity-50"}`} data-testid={`pm-row-${m.id}`}>
                <td className="px-2 py-1.5 font-medium">{m.name}{!m.active && <span className="ml-1 text-[10px] text-slate-500">(Pasif)</span>}{m.note && <div className="text-[11px] text-slate-500">{m.note}</div>}</td>
                <td className="px-2 py-1.5">{m.material_type}</td>
                <td className="px-2 py-1.5 font-mono">{fmtQty(m.usage_qty)}</td>
                <td className="px-2 py-1.5 font-mono font-semibold" data-testid={`pm-stock-${m.id}`}>{fmtQty(m.stock_qty)} <span className="text-[10px] text-slate-400">{m.unit}</span></td>
                <td className="px-2 py-1.5 font-mono">{fmtQty(m.critical_stock)}</td>
                <td className="px-2 py-1.5"><MaterialStatus status={m.status} testid={`pm-status-${m.id}`} /></td>
                <td className="px-2 py-1.5 text-xs">{m.default_supplier_name || "—"}</td>
                <td className="px-2 py-1.5"><div className="flex gap-1 justify-end">
                  <Btn size="sm" variant="ghost" onClick={() => setHist(m)} title="Hareket Geçmişi" data-testid={`pm-history-${m.id}`}><History size={12} /> Geçmiş</Btn>
                  {canEdit && <>
                    <Btn size="sm" variant="ghost" onClick={() => setForm({ material: m })} data-testid={`pm-edit-${m.id}`}><Pencil size={12} /></Btn>
                    <Btn size="sm" variant="ghost" onClick={() => setCount(m)} title="Stok Sayımı" data-testid={`pm-count-${m.id}`}><ClipboardCheck size={12} /></Btn>
                    <Btn size="sm" variant="ghost" onClick={() => del(m)} data-testid={`pm-delete-${m.id}`}><Trash2 size={12} /></Btn>
                  </>}
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
      <MaterialFormModal open={!!form} productId={productId} material={form?.material} suppliers={suppliers}
        onClose={() => setForm(null)} onSaved={() => { setForm(null); load(); }} />
      <MaterialHistoryModal material={hist} onClose={() => setHist(null)} />
      <MaterialCountModal material={count} onClose={() => setCount(null)} onSaved={() => { setCount(null); load(); }} />
    </>
  );
}
